import { useCallback, useState } from 'react';
import { useCookies } from 'react-cookie';

import { useMember } from '../../context/member';

export const useHeader = () => {
  const member = useMember();
  const [token, setToken, removeToken] = useCookies(['accessToken']);

  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = useCallback(async () => {
    const response = await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      alert('로그아웃에 실패하였습니다.');
      return;
    }

    alert('로그아웃 되었습니다.');

    window.location.replace('/');
  }, []);

  return {
    member,
    token,
    setToken,
    showMenu,
    toggleMenu,
    handleLogout,
  };
};
